<template>
  <v-container>
    <h1>Attendance</h1>
    <StudentLoader/>
  </v-container>
</template>

<script>
import StudentLoader from "../components/StudentLoader";
export default {
  name: "Attendance",
  data() {
    return {
      users: ""
    };
  },
  components: {
    StudentLoader
  },
  methods: {}
};
</script>
